// extracted by mini-css-extract-plugin
module.exports = {"separator":"wm_nM","dot":"RouLj"};